export default "skymp5-front/482144170123d2d1b98c3be85563209c.png";